import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Drawer from 'rc-drawer';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { Button } from 'reactstrap';
import FeatureDetail from 'components/Agile/feature/featureDetail';
import FeatureTable from 'components/Agile/feature/featureTable';
import FeatureAdd from 'components/Agile/feature/featureMaintenance/featureAdd';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress';
import CustomScrollbars from 'util/CustomScrollbars';
import {
    fetchFeatures,
    handleFeatureRequestClose,
    showFeatureLoader,
    onAddFeature,
    onToggleFeatureDrawer,
} from 'actions/feature';
import {
    fetchInitiatives,
} from 'actions/initiative';

const Component = () => {
    const dispatch = useDispatch();

    const width = useSelector(state => state.settings.width);
    const loader = useSelector(state => state.features.loader);
    const alertMessage = useSelector(state => state.features.alertMessage);
    const showMessage = useSelector(state => state.features.showMessage);
    const noContentFoundMessage = useSelector(state => state.features.noContentFoundMessage);
    const drawerState = useSelector(state => state.features.drawerState);
    const feature = useSelector(state => state.features.feature);
    const featureList = useSelector(state => state.features.featureList);

    useEffect(() => {
        dispatch(showFeatureLoader());
        dispatch(fetchFeatures());
        dispatch(fetchInitiatives());
        // need to fetchInitiatives when they are available
    }, []);

    const featureSideBar = () => {
        return <div className="module-side">
            <div className="module-side-header">
                <div className="module-logo">
                    <i className="zmdi zmdi-city-alt mr-4" />
                    <span><IntlMessages id="sidebar.features" /></span>
                </div>
            </div>

            <div className="module-side-content">
                <CustomScrollbars className="module-side-scroll scrollbar"
                    style={{ height: width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)' }}>
                    <div className="module-add-task">
                        <Button className="btn-block jr-btn" color="primary"
                            onClick={() => dispatch(onAddFeature())}>
                            <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                            <span><IntlMessages id="feature.addFeature" /></span>
                        </Button>
                    </div>
                </CustomScrollbars>
            </div>
        </div>;
    };

    const featureRequestClose = () => {
        dispatch(handleFeatureRequestClose());
    };

    return (
        <div className="app-wrapper">
            <div className="app-module animated slideInUpTiny animation-duration-3">
                <div className="d-block d-xl-none">
                    <Drawer
                        touch={true}
                        transitions={true}
                        enableDragHandle={true}
                        open={drawerState}
                        onOpenChange={() => dispatch(onToggleFeatureDrawer())}
                        sidebar={featureSideBar(feature)} />
                </div>
                <div className="app-module-sidenav d-none d-xl-flex">
                    {featureSideBar(feature)}
                </div>
                <div className="module-box">
                    <div className="module-box-content">
                        <div className="module-box-header">
                            <span className="icon-btn drawer-btn d-flex d-xl-none"
                                onClick={() => dispatch(onToggleFeatureDrawer())}>
                                <i className="zmdi zmdi-menu" />
                            </span>
                        </div>
                        <CustomScrollbars className="module-list-scroll scrollbar"
                            style={{ height: width >= 1200 ? 'calc(108vh - 265px)' : 'calc(108vh - 245px)' }}>
                            {loader ?
                                <div
                                    className="loader-view-block h-100">
                                    <div className="loader-view">
                                        <CircularProgress />
                                    </div>
                                </div>
                                :
                                featureList && featureList.length > 0 ?
                                    <Fragment>
                                        <div className="app-main-content">
                                            <FeatureTable />
                                            <div style={{ marginTop: 10 }}>
                                                <FeatureDetail />
                                            </div>
                                        </div>
                                    </Fragment>
                                    :
                                    <div className="h-100 d-flex align-items-center justify-content-center">
                                        {noContentFoundMessage}
                                    </div>
                            }
                        </CustomScrollbars>

                    </div>
                </div>
            </div>
            <FeatureAdd />

            {showMessage && NotificationManager.success(alertMessage, featureRequestClose())}
            <NotificationContainer />

        </div>
    );
};

export default Component;



// WEBPACK FOOTER //
// ./components/Agile/feature/component.js